import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {
    phoneBadgeSx,
    phoneCardHeadSx,
    phonePersonBadgeSx,
    phoneSubtitleSx,
    phoneTitleSx,
} from '../mobileDesign.sx';
import {PhoneCardHeadProps} from './PhoneCardHead.types';

/**
 * The top line of a list card, as drawn: a badge saying what kind of thing this is, the name people
 * search by, the line that tells two similar ones apart, and the row's own menu.
 *
 * It exists so that twenty lists cannot each invent their own arrangement of the same four things —
 * which is what the cards did before, and why no two of them lined up.
 */
export const PhoneCardHead: FC<PhoneCardHeadProps> = ({icon, person, title, subtitle, action}) => (
    <Box sx={phoneCardHeadSx}>
        {icon && <Box sx={person ? phonePersonBadgeSx : phoneBadgeSx}>{icon}</Box>}
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '3px', flexGrow: 1, minWidth: 0}}>
            {/* `component="div"`, not the paragraph a Typography renders by default: a title is often
                a node the list already had - a description cell, a link with a copy button, an
                invoice preview - and those render divs, which a <p> may not contain. */}
            <Typography
                component="div"
                sx={phoneTitleSx}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography
                    component="div"
                    sx={phoneSubtitleSx}
                >
                    {subtitle}
                </Typography>
            )}
        </Box>
        {action}
    </Box>
);
